// EXTENSIONS
import WelcomeMatExtensionContainer from './containers/WelcomeMatExtensionContainer';
import RegisterExtension from './site-render/src/RegisterExtension';
// SECTIONS
import AppSection from './site-render/src/AppSection';
import BenefitsSection from './site-render/src/BenefitsSection';
import CTAColumnSection from './site-render/src/CTAColumnSection';
import CTARowSection from './site-render/src/CTARowSection';
import ExhibitorsSection from './site-render/src/ExhibitorsSection';
import EditionsSection from './site-render/src/EditionsSection';
import ListSection from './site-render/src/ListSection';
import FooterSection from './site-render/src/FooterSection';
import HeaderSection from './site-render/src/HeaderSection';
import HighlightSection from './site-render/src/HighlightSection';
import LeadSectionContainer from './containers/LeadSectionContainer';
import LocationSection from './site-render/src/LocationSection';
import MenuSection from './site-render/src/MenuSection';
import PersonSection from './site-render/src/PersonSection';
import ScheduleSection from './site-render/src/ScheduleSection';
import SpeakersSection from './site-render/src/SpeakersSection';
import SponsorsSection from './site-render/src/SponsorsSection';

const extensions = {
  welcomeMat: WelcomeMatExtensionContainer,
  register: RegisterExtension,
};

const sections = {
  app: AppSection,
  benefits: BenefitsSection,
  ctaColumn: CTAColumnSection,
  ctaRow: CTARowSection,
  editions: EditionsSection,
  exhibitors: ExhibitorsSection,
  list: ListSection,
  footer: FooterSection,
  header: HeaderSection,
  highlight: HighlightSection,
  embeddedVideoHighlight: HighlightSection,
  lead: LeadSectionContainer,
  location: LocationSection,
  menu: MenuSection,
  person: PersonSection,
  schedule: ScheduleSection,
  speakers: SpeakersSection,
  sponsors: SponsorsSection,
};

export default {
  ...extensions,
  ...sections,
};



// WEBPACK FOOTER //
// ./src/siteComponentTypes.js